export default {
  state: {
    errored: false,
    errorMsg: 'Unknown error',
  },
  getters: {
    getErrored: state => state.errored,
    getErrorMsg: state => state.errorMsg,
  },
  mutations: {
    setErrored(state, bool) {
      state.errored = bool;
    },
    setErrorMsg(state, msg) {
      state.errorMsg = msg;
    },
  },
  actions: {},
};
